import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "batch-maintain"
};
const _hoisted_2 = {
  class: "batch-maintain-table"
};
const _hoisted_3 = {
  class: "recover-condition"
};
const _hoisted_4 = {
  class: "btn-group"
};
import { onMounted, ref, toRefs, reactive, computed, watch } from 'vue';
import { queryComponent, updateMaintain } from '@/api/management/batchOperation';
import { ElMessage } from 'element-plus';
import { differenceInMinutes } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { useUserDefaultSettingStore } from '@/store/user';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'batch-maintain-dialog',
  props: {
    visible: {
      type: Boolean
    },
    clusterIdList: {},
    zoneIdList: {},
    checkIdList: {}
  },
  emits: ["confirm", "update:visible"],
  setup(__props, {
    emit: __emit
  }) {
    const store = useUserDefaultSettingStore();
    const {
      timeZone,
      userName,
      timeZoneArea
    } = storeToRefs(store);
    const props = __props;
    const {
      visible,
      clusterIdList,
      zoneIdList,
      checkIdList
    } = toRefs(props);
    const maintainServerRef = ref();
    const maintainForm = reactive({
      id: 0,
      selectedAgents: [],
      name: '',
      status: 2,
      time: '',
      is5PollsPass: true,
      isTicketDone: true,
      memo: '',
      ticketnum: ''
    });
    const rules = reactive({
      memo: [{
        required: true,
        message: 'Please input the description',
        trigger: 'blur'
      }]
    });
    const autoRecoverRadio = ref(2);
    const autoRecoverTime = ref('');
    const autoRecoverDuration = ref();
    const autoRecoverDurationOptions = [{
      value: '30',
      label: '0.5 hour'
    }, {
      value: '60',
      label: '1 hour'
    }, {
      value: '120',
      label: '2 hour'
    }, {
      value: '180',
      label: '3 hour'
    }, {
      value: '240',
      label: '4 hour'
    }, {
      value: '300',
      label: '5 hour'
    }, {
      value: '360',
      label: '6 hour'
    }, {
      value: '1440',
      label: '1 day'
    }, {
      value: '2880',
      label: '2 days'
    }, {
      value: '4320',
      label: '3 days'
    }, {
      value: '999999',
      label: 'Never'
    }];
    const tableData = ref([]);
    const initTable = async () => {
      const clusterIds = clusterIdList.value.join('_') || 0;
      const zoneIds = zoneIdList.value.join('_') || 0;
      const checkIds = checkIdList.value.join('_') || 0;
      const {
        ServerList
      } = await queryComponent(checkIds, zoneIds, clusterIds);
      tableData.value = ServerList;
    };
    const computedTableData = computed(() => tableData.value.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value));
    const currentPage = ref(1);
    const pageSize = ref(10);
    const itemNumber = computed(() => tableData.value.length);
    const validateForm = async () => {
      if (!maintainServerRef.value) return;
      await maintainServerRef.value.validate(valid => {
        if (autoRecoverRadio.value === 2 && autoRecoverDuration.value === '999999' && !maintainForm.ticketnum) {
          ElMessage({
            type: 'error',
            message: 'Auto recover cannot be never if there is no ticket number'
          });
        } else if (valid) {
          handleMaintenance();
        }
      });
    };
    const handleMaintenance = async () => {
      const currTime = formatInTimeZone(new Date(), timeZoneArea.value, 'yyyy-MM-dd HH:mm:ss');
      const duration = autoRecoverRadio.value === 1 ?
      // @ts-ignore
      differenceInMinutes(new Date(autoRecoverTime.value), new Date(currTime)) : autoRecoverDuration.value || 1440;
      const CommonMaintainList = [];
      tableData.value?.map(item => {
        let id = 0;
        let type = 0;
        if (item.clusterId !== 0) {
          id = item.clusterId;
          type = 0;
        } else if (item.zoneId !== 0) {
          id = item.zoneId;
          type = 2;
        } else if (item.serverId !== 0) {
          id = item.serverId;
          type = 3;
        }
        CommonMaintainList.push({
          forceMaintain: (maintainForm.is5PollsPass ? 2 : 0) + (maintainForm.isTicketDone ? 1 : 0),
          id,
          memo: maintainForm.memo,
          recover: duration,
          status: maintainForm.status,
          ticketnum: maintainForm.ticketnum,
          type,
          username: userName.value
        });
      });
      await updateMaintain(timeZone.value, CommonMaintainList, false);
      ElMessage({
        type: 'success',
        message: 'Maintain Successfully'
      });
      handleBeforeClose();
      if (!maintainForm.ticketnum) {
        ElMessage({
          type: 'warning',
          message: 'Use a default ticket number since it was not provided'
        });
      }
    };
    const emits = __emit;
    const dialogVisible = ref(false);
    const handleBeforeClose = () => {
      emits('update:visible', false);
    };
    const handleCancel = () => {
      emits('update:visible', false);
    };
    onMounted(() => {
      dialogVisible.value = visible.value;
    });
    const clearDialog = () => {
      maintainServerRef.value?.resetFields();
      autoRecoverRadio.value = 2;
      autoRecoverTime.value = '';
      autoRecoverDuration.value = '1440';
    };
    watch(() => visible.value, () => {
      dialogVisible.value = visible.value;
      if (dialogVisible.value) {
        initTable();
      } else {
        clearDialog();
      }
    });
    return (_ctx, _cache) => {
      const _component_dialog_header = _resolveComponent("dialog-header");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => dialogVisible.value = $event),
        "show-close": false,
        width: "60%",
        "before-close": handleBeforeClose
      }, {
        header: _withCtx(({
          close
        }) => [_createVNode(_component_dialog_header, {
          onClose: close,
          "header-name": "Batch Maintain"
        }, null, 8, ["onClose"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_table, {
          data: computedTableData.value,
          style: {
            "width": "99%"
          },
          "row-key": "id",
          border: "",
          "default-expand-all": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "index",
            index: index => index + 1
          }, null, 8, ["index"]), _createVNode(_component_el_table_column, {
            prop: "clusterName",
            label: "Cluster"
          }), _createVNode(_component_el_table_column, {
            prop: "zoneName",
            label: "Zone"
          }), _createVNode(_component_el_table_column, {
            prop: "serverIp",
            label: "Check"
          })]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_pagination, {
          "current-page": currentPage.value,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => currentPage.value = $event),
          "page-size": pageSize.value,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
          "page-sizes": [10, 20, 50],
          layout: "total, sizes, prev, pager, next",
          class: "batch-maintain-pagination mt-10",
          total: itemNumber.value
        }, null, 8, ["current-page", "page-size", "total"])]), _createVNode(_component_el_form, {
          class: "maintain-form",
          ref_key: "maintainServerRef",
          ref: maintainServerRef,
          model: maintainForm,
          rules: rules,
          "label-position": "top",
          "label-width": "150px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "Maintain"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: maintainForm.status,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => maintainForm.status = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                value: 1
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("Offline")])),
                _: 1
              }), _createVNode(_component_el_radio, {
                value: 2
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("Maintain")])),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "Recover Condition"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_checkbox, {
              modelValue: maintainForm.is5PollsPass,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => maintainForm.is5PollsPass = $event)
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode(" 5 polls pass ")])),
              _: 1
            }, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
              modelValue: maintainForm.isTicketDone,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => maintainForm.isTicketDone = $event),
              disabled: ""
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode(" Ticket done ")])),
              _: 1
            }, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "Auto Recover"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: autoRecoverRadio.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => autoRecoverRadio.value = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                value: 1
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  placeholder: "Select Date and Time",
                  modelValue: autoRecoverTime.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => autoRecoverTime.value = $event),
                  type: "datetime"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_radio, {
                value: 2
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: autoRecoverDuration.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => autoRecoverDuration.value = $event),
                  class: "m-2",
                  placeholder: "1 Day"
                }, {
                  default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(autoRecoverDurationOptions, item => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]);
                  }), 64))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "memo",
            label: "Description"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: maintainForm.memo,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => maintainForm.memo = $event),
              class: "table-input",
              placeholder: "Memo"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "Ticket Number"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: maintainForm.ticketnum,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => maintainForm.ticketnum = $event),
              class: "table-input",
              placeholder: "Ticket"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          onClick: handleCancel
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("Cancel")])),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: validateForm,
          type: "success"
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("Submit")])),
          _: 1
        })])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});